import { BookingAction } from '../actions/booking-action';
import { UnifiedFromBufferstockAction } from '../actions/unified/unified-from-bufferstock-action';
import { UnifiedFromCarAction } from '../actions/unified/unified-from-car-action';
import { UnifiedFromMachineAction } from '../actions/unified/unified-from-machine-action';
import { StockSourceType } from '../types';
import { BookingWorld, WorldKind } from './booking-world';

/**
 * KFZ + Bufferstock aktiv. Alle drei Quellen verfügbar; die
 * welt-übergreifenden Richtungen (KFZ<->Bufferstock, KFZ->Maschine als
 * CarTransfer) leben hier.
 */
export class UnifiedWorld implements BookingWorld {
  public readonly kind: WorldKind = 'unified';

  private readonly actions: Partial<Record<StockSourceType, BookingAction>> = {
    [StockSourceType.BUFFERSTOCK]: new UnifiedFromBufferstockAction(),
    [StockSourceType.CAR]: new UnifiedFromCarAction(),
    [StockSourceType.MACHINE]: new UnifiedFromMachineAction(),
  };

  /**
   * Liefert die Source-Action für die Unified-Welt.
   * @param source Quell-Lagertyp der Buchung.
   * @returns Die Action für BUFFERSTOCK, CAR oder MACHINE, sonst undefined.
   */
  public actionFor(source: StockSourceType): BookingAction | undefined {
    return this.actions[source];
  }
}
